<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">{{ $t("B0300.titles[0]") }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!valid || isFormalSa || isPreSa || !editable"
          @click="save"
          small
          v-permit.SHARP_INV_SAVE
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <table-upload
          title="upload inv"
          @input="upload"
          v-permit.SHARP_INV_UPLOAD_INV
          v-if="
            $route.path.indexOf('new') !== -1 && $route.query.type === 'paid'
          "
        />
        <v-btn
          :disabled="!canRemove"
          @click="remove"
          small
          v-if="$route.path.indexOf('new') === -1"
          v-permit.SHARP_INV_DELETE
          >{{ $t("app.buttons.remove") }}</v-btn
        >
        <v-btn @click="back" small>{{ $t("app.buttons.back") }}</v-btn>
        <v-btn
          @click="createTempCompany"
          small
          v-if="$route.query.type === 'unpaid'"
          >海外取引先登録</v-btn
        >

        <a @click="$downloadTemplate('B0300', 'sytc')" href="#"
          >SYTC I/V Upload template</a
        >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a @click="$downloadTemplate('B0300', 'sku')" href="#"
          >SKU Upload template</a
        >

        <!-- <a
          @click="$downloadTemplate('B0300','iv')"
          href="#"
          style="margin-left: 10px"
        >IV UP template</a>-->
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-card-title primary-title style="padding-left: 8px">
        <span class="headline mb-0">{{ $t("B0300.titles[1]") }}</span>
      </v-card-title>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!companyEditable"
                :label="$t('app.labels.company.name')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.company.name') +
                      $t('app.validator.messages.required'),
                ]"
                required
                url="companies/kv?type=SHARP"
                v-model="invoice.companyId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!buEditable"
                :label="$t('app.labels.bu.name')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.bu.name') +
                      $t('app.validator.messages.required'),
                ]"
                required
                :url="`divisions/kv?type=BU&companyId=${invoice.companyId}`"
                v-model="invoice.buId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!partnerEditable || $route.query.type === 'paid'"
                :label="$t('app.labels.partner')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.partner') +
                      $t('app.validator.messages.required'),
                ]"
                ref="partner"
                required
                url="companies/kv?type=PARTNER"
                v-model="invoice.partnerId"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :disabled="!editable"
                :label="$t('app.labels.ivNo')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.ivNo') +
                      $t('app.validator.messages.required'),
                  (v) =>
                    String(v).length <= 10 ||
                    $t('app.validator.messages.lessThanEight'),
                ]"
                clearable
                v-model="invoice.invoiceNo"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                :disabled="!editable"
                :label="$t('app.labels.creationDate')"
                :required="true"
                v-model="invoice.creationDate"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!editable"
                :label="$t('app.labels.loadingPort')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.loadingPort') +
                      $t('app.validator.messages.required'),
                ]"
                url="ports/kv"
                v-model="invoice.loadingPortCode"
              />
            </v-flex>
            <v-flex xs3>
              <remote-select
                :disabled="!editable"
                :label="$t('app.labels.transportMode')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.transportMode') +
                      $t('app.validator.messages.required'),
                ]"
                url="transport-modes/kv"
                v-model="invoice.transportModeId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!editable"
                :label="$t('app.labels.incoterm')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.incoterm') +
                      $t('app.validator.messages.required'),
                ]"
                item-text="code"
                :url="incotermKvUrl"
                v-model="invoice.incotermId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!editable"
                :label="$t('app.labels.dischargePort')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.dischargePort') +
                      $t('app.validator.messages.required'),
                ]"
                url="ports/kv"
                v-model="invoice.dischargePortCode"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :disabled="!editable"
                :label="$t('app.labels.currency')"
                :rules="[
                  (v) =>
                    !!v ||
                    $t('app.labels.currency') +
                      $t('app.validator.messages.required'),
                ]"
                url="currencies/kv"
                v-model="invoice.currencyCode"
              />
            </v-flex>
            <v-flex xs3>
              <date-input
                :disabled="!editable"
                :label="$t('app.labels.etd')"
                :required="true"
                v-model="invoice.etd"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <invoice-item-list
      :invoice="invoice"
      :purchaseOrder="purchaseOrder"
      :type="$route.query.type"
      @initData="initData"
      @initUploadData="initUploadData"
      @invoiceUpload="packageData"
      @uploadUnpaidData="uploadUnpaidData"
      class="mt-2"
      ref="invoiceItemList"
    />
    <package-list
      :invoice="invoice"
      @packageUpload="packageUpload"
      class="mt-2"
      ref="packingItemList"
    />
    <add-partner-dialog @refreshPartner="refreshPartner" ref="partnerDialog" />
    <alert-dialog ref="alertDialog" />
  </v-container>
</template>

<script>
import InvoiceItemList from "./InvoiceItemList";
import PackageList from "./PackageList";
import AddPartnerDialog from "./AddPartnerDialog";
import AlertDialog from "./AlertDialog";

export default {
  components: { InvoiceItemList, PackageList, AddPartnerDialog, AlertDialog },
  data() {
    return {
      refresh: null,
      valid: true,
      purchaseOrder: [],
      invoice: {
        invoiceNo: null,
        partnerId: null,
        items: [],
        packages: [],
      },
      errors: {
        INVOICE_NO_DUPLICATE: this.$t("B0300.messages.errors.ivNoExist"),
        PACKAGE_QTY_OVER: this.$t("B0300.messages.errors.hugeQty"),
        PAY_SITE_NOT_UNIQUE: this.$t("B0300.messages.errors.paysit_not_unique"), //'回収支払方法，支払サイト，起算日条件区分が違うため、INV作成できません。'
        NO_PRODUCT: this.$t("B0300.messages.errors.no_product"),
        INV_HAS_USED: "当該INVは既に利用されています。",
      },
    };
  },
  methods: {
    // incotermBind(incoterm) {
    //   this.invoice.incotermId = (incoterm && incoterm.value) || null
    // },
    upload(data) {
      this.invoice.invoiceNo = this.getUploadInvoiceNo(data);
      this.invoice.creationDate = this.getUploadInvoiceCreationDate(data);
      this.setUploadItemsAndPackages(data);
    },

    getUploadInvoiceNo(data) {
      return data.find((d) => d[0] === "InvoiceNo")[1];
    },

    getUploadInvoiceCreationDate(data) {
      let day = data.find((d) => d[0] === "InvoiceDate")[1];
      try {
        return day.replaceAll("/", "-");
      } catch (e) {
        this.throwError(`InvoiceDateの形式が正しくありません。`);
      }
    },

    getUploadPoItems(data) {
      let startIndex = -1;
      let endIndex = -1;
      for (let i = 0; i < data.length; i++) {
        if (data[i].length >= 2 && data[i][1] === "PO") {
          startIndex = i;
          break;
        }
      }
      for (let i = 0; i < data.length; i++) {
        if (
          data[i].length >= 1 &&
          data[i][0] === "PackingList" &&
          i > startIndex
        ) {
          endIndex = i;
          break;
        }
      }
      return data
        .slice(startIndex + 1, endIndex - 1)
        .map((d) => {
          d[1] = (d[1] + "").substring(
            0,
            (d[1] + "").length >= 7 ? 7 : (d[1] + "").length
          );
          return d;
        })
        .reduce((a, b) => {
          const target = a.find((d) => d[1] === b[1]);
          if (target) {
            if (target[2] !== b[2]) {
              this.throwError(`同じponoですが、itemnoに一貫性がありません`);
            }
            target[3] += b[3];
          } else {
            a.push(b);
          }
          return a;
        }, []);
    },

    throwError(message) {
      this.$message(this.$t("app.messages.errors.title"), message);
      throw new Error(message);
    },

    getUploadPackingItems(data) {
      let startIndex = -1;
      let endIndex = -1;
      for (let i = 0; i < data.length; i++) {
        if (data[i].length >= 2 && data[i][1] === "ItemNo") {
          startIndex = i;
          break;
        }
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].length >= 2 && data[i][1] === "Total" && i > startIndex) {
          endIndex = i;
          break;
        }
      }
      return data.slice(startIndex + 1, endIndex);
    },

    isFieldRepeat(arr, fieldMap) {
      let fields = arr.map(fieldMap).sort();
      for (let i = 0; i < fields.length - 1; i++) {
        if (fields[i] == fields[i + 1]) {
          return true;
        }
      }
      return false;
    },

    fieldSortAndJoin(arr, fieldMap) {
      return arr
        .map(fieldMap)
        .sort()
        .reduce((a, b) => a + "," + b, "");
    },

    isUploadPosAndPackingsValid(pos, packages) {
      let poItemNos = pos.map((p) => p[2]);
      let packingItemNos = packages.map((p) => p[1]);
      for (let i = 0; i < packingItemNos.length; i++) {
        if (poItemNos.find((item) => item === packingItemNos[i]) == null) {
          // this.$message(
          //   this.$t('app.messages.errors.title'),
          //   `PackingList のItemNo：<span>${packingItemNos[i]}</span>がＰＯと不一致です。`
          // )
          this.$refs.alertDialog.popup(packingItemNos[i]);
          return false;
        }
      }
      return true;
    },

    setUploadItemsAndPackages(data) {
      let pos = this.getUploadPoItems(data);
      let packages = this.getUploadPackingItems(data);

      if (!this.isUploadPosAndPackingsValid(pos, packages)) {
        return;
      }

      this.$http
        .get(
          `purchase-orders/get-upload/${pos
            .map((po) => po[1] + "")
            .reduce((a, b) => a + "," + b)}`
        )
        .then((res) => {
          if (
            this.fieldSortAndJoin(pos, (po) => po[1] + "") !==
            this.fieldSortAndJoin(res.data, (po) => po.poNo)
          ) {
            const poNo =
              pos.find(
                (po) => res.data.find((p) => po[1] + "" === p.poNo) == null
              )[1] + "";

            this.$message(
              this.$t("app.messages.errors.title"),
              `Po.No"${poNo}"がシステムに存在しません。または、利用できません`
            );
            return;
          }

          //根据excel po item信息构造出系统可使用po item信息
          let newItems = pos.map((p, index) => {
            const s = res.data.find((item) => p[1] + "" === item.poNo);
            return {
              ...s,
              poItemId: s.id,
              id: null,
              seq: new Date().getTime() + index,
              qty: p[3],
              max: s.leftInvoice,
              outerSkuCode: p[2],
              used: 0,
            };
          });

          const newPackages = packages
            .map((p, index) => {
              return this.splitPackages(
                p,
                newItems.filter((item) => item.outerSkuCode === p[1]),
                index
              );
            })
            .reduce((a, b) => {
              return [...a, ...b];
            }, []);

          newPackages.forEach((pkg) => {
            if (
              newPackages.filter((p) => p.sourcePkgIndex === pkg.sourcePkgIndex)
                .length > 1
            ) {
              pkg.cartonStartNo = null;
              pkg.cartonEndNo = null;
              pkg.perCartonQty = null;
            }
          });

          if (this.hasSamePo(newItems)) {
            this.$message(
              this.$t("app.messages.errors.title"),
              this.$t("B0300.messages.errors.duplicatePO")
            );
            return;
          }

          if (this.hasDifPartner(newItems)) {
            this.$message("", this.$t("B0300.messages.errors.partner_unique")); //'different partners'
            return;
          }

          this.invoice.items = [...this.invoice.items, ...newItems];
          this.initData(newItems);

          //根据构造出的系统可使用的po item信息和 excel 的package信息构造系统可使用的package 信息
          this.invoice.packages = [...this.invoice.packages, ...newPackages];
        });
    },

    splitPackages(pkg, poItems, index) {
      const arr = [];
      for (let i = 0; i < poItems.length; i++) {
        if (poItems[i].qty - poItems[i].used === 0) continue;
        if (pkg[2] <= poItems[i].qty - poItems[i].used) {
          poItems[i].used += pkg[2];
          arr.push({
            item: poItems[i],
            ...poItems[i],
            itemSeq: poItems[i].seq,
            seq: new Date().getTime() + index * 1000,
            totalQty: pkg[2],
            totalNetWeight: this.$numberScale2(pkg[3]),
            totalGrossWeight: this.$numberScale2(pkg[4]),
            totalVolume: this.$numberScale3(pkg[5]),
            cartonStartNo: pkg.length > 6 ? pkg[6] : null,
            cartonEndNo: pkg.length > 7 ? pkg[7] : null,
            sourcePkgIndex: index,
            perCartonQty:
              pkg.length > 7 ? pkg[2] / (pkg[7] - pkg[6] + 1) : null,
          });
          break;
        } else {
          const usedN =
            Math.round(
              ((pkg[3] * (poItems[i].qty - poItems[i].used)) / pkg[2]) * 100
            ) / 100;
          const usedG =
            Math.round(
              ((pkg[4] * (poItems[i].qty - poItems[i].used)) / pkg[2]) * 100
            ) / 100;
          const usedM =
            Math.round(
              ((pkg[5] * (poItems[i].qty - poItems[i].used)) / pkg[2]) * 1000
            ) / 1000;

          arr.push({
            item: poItems[i],
            ...poItems[i],
            itemSeq: poItems[i].seq,
            seq: new Date().getTime() + index * 1000,
            totalQty: poItems[i].qty - poItems[i].used,
            totalNetWeight: usedN,
            totalGrossWeight: usedG,
            totalVolume: usedM,
            cartonStartNo: pkg.length > 6 ? pkg[6] : null,
            cartonEndNo: pkg.length > 7 ? pkg[7] : null,
            sourcePkgIndex: index,
            perCartonQty:
              pkg.length > 7
                ? (poItems[i].qty - poItems[i].used) / (pkg[7] - pkg[6] + 1)
                : null,
          });

          pkg = [
            1,
            poItems[i].outerSkuCode,
            pkg[2] - poItems[i].qty + poItems[i].used,
            Math.round((pkg[3] - usedN) * 100) / 100,
            Math.round((pkg[4] - usedG) * 100) / 100,
            Math.round((pkg[5] - usedM) * 1000) / 1000,
          ];
          poItems[i].used += poItems[i].qty - poItems[i].used;
        }
      }

      return arr;
    },

    hasSamePo(selected) {
      for (var i = 0; i < this.invoice.items.length; i++) {
        for (var j = 0; j < selected.length; j++) {
          if (this.invoice.items[i].poNo == selected[j].poNo) {
            return true;
          }
        }
      }
    },

    hasDifPartner(selected) {
      var temp = [];
      temp = [...selected, ...this.invoice.items];
      var partner = temp
        .filter((i) => !!i.partnerId)
        .map((i) => i.partnerId)
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i);
          }
          return t;
        }, []);
      if (partner.length > 1) {
        return true;
      } else {
        return false;
      }
    },

    refreshPartner() {
      this.$refs.partner.load();
    },
    createTempCompany() {
      this.$refs.partnerDialog.popup();
    },
    packageUpload(data) {
      this.invoice.packages = [...this.invoice.packages, ...data];
    },
    initUploadData(data) {
      var newPackage = [];
      var itemList = [];

      data.forEach((d, index) => {
        if (itemList.map((i) => i.poNo).indexOf(d.poNo) === -1) {
          itemList.push({ ...d, seq: new Date().getTime() + index });
        } else {
          // itemList.find(i => i.poNo === d.poNo).totalQty += d.totalQty
          itemList.find((i) => i.poNo === d.poNo).qty += d.qty;
        }
      });

      this.invoice.items = [...this.invoice.items, ...itemList];
      this.invoice.packages = [...this.invoice.packages, ...data];

      this.invoice.packages.forEach((p, index) => {
        this.invoice.items.forEach((i) => {
          if (p.poNo == i.poNo) {
            newPackage.push({
              ...p,
              item: i,
              itemSeq: i.seq,
              seq: new Date().getTime() + index,
            });
          }
        });
      });

      this.invoice.items.forEach((item, index) => {
        item.qty = 0;
        this.invoice.packages.forEach((pkg) => {
          if (item.poNo === pkg.poNo) {
            item.qty += pkg.totalQty;
          }
        });
      });

      this.invoice.packages = newPackage;

      this.initData(data);
    },
    packageData(item, p) {
      this.invoice.items = [...this.invoice.items, ...item];
      this.invoice.packages = [...this.invoice.packages, ...p];
      this.initData(item);
    },
    initData(pos) {
      console.log(pos.length);
      this.invoice = {
        ...this.invoice,
        invoiceNo: this.invoice.invoiceNo || pos[0].invoiceNo,
        partnerId: this.invoice.partnerId || pos[0].partnerId,
        loadingPortCode: this.invoice.loadingPortCode || pos[0].loadingPortCode,
        incotermId: this.invoice.incotermId || pos[0].incotermId,
        dischargePortCode:
          this.invoice.dischargePortCode || pos[0].dischargePortCode,
        currencyCode: this.invoice.currencyCode || pos[0].currencyCode,
        transportModeId: this.invoice.transportModeId || pos[0].transportModeId,
        buId: this.invoice.buId || pos[0].buId,
        companyId: this.invoice.companyId || pos[0].companyId,
      };
    },
    uploadUnpaidData(data) {
      var domestic = data.filter((d) => "諸掛" === d.skuCode);
      // if (domestic.length > 0 && this.invoice.items.length > 0) {
      //   this.$message('', '１件のINVに諸掛と品番が同時に存在できません。')
      //   return
      // }
      this.invoice.items = [...this.invoice.items, ...data];
      this.invoice.packages = [...this.invoice.packages, ...data];
    },
    canSave() {
      if (this.$route.query.type === "paid" || this.invoice.isPaid) {
        if (
          this.invoice.incotermId === "INCOTERM-DAP" ||
          this.invoice.incotermId === "INCOTERM-DDP"
        ) {
          this.$message(
            this.$t("app.messages.errors.title"),
            this.$t("app.labels.incoterm") +
              this.$t("app.validator.messages.required")
          );
          return false;
        }
      }
      if (this.invoice.items && this.invoice.items.length == 0) {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.$t("B0300.messages.errors.invalidItem")
        );
        return false;
      }
      if (this.invoice.packages && this.invoice.packages.length == 0) {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.$t("B0300.messages.errors.invalidPacking")
        );
        return false;
      }
      var array = this.calPackagesAmount();
      for (var i = 0; i < array.length; i++) {
        if (array[i].subTotal != array[i].max) {
          this.$message(
            this.$t("app.messages.errors.title"),
            this.$t("B0300.messages.errors.invalidPackageQty", {
              po: array[i].poNo,
            })
          );
          return false;
        }
      }
      if (
        (this.calItem() && this.calItem().length) !=
        (this.calPackage() && this.calPackage().length)
      ) {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.$t("B0300.messages.errors.notFullyPackaged")
        );
        return false;
      }
      for (var j = 0; j < this.invoice.packages.length; j++) {
        if (this.hasPoint(this.invoice.packages[j].perCartonQty)) {
          this.$message(
            "",
            this.$t("B0300.messages.errors.per_carton_qty_integer")
          ); //入数が整数ではないですので、再修正ください。
          return false;
        }
      }

      if (this.hasDifBu()) {
        this.$message("", this.$t("B0300.messages.errors.buDifferent")); //'Invoiceに複数事業本部のPOが入れられません。'
        return false;
      }

      if (!this.amountEqual()) {
        this.$message("", this.$t("B0300.messages.errors.qtyNotMatch")); //'INV詳細とPLの数量が違うため、保存できません。'
        return false;
      }
      if (this.missNwGwM3()) {
        this.$message("", this.$t("B0300.messages.errors.nw_gw_m3_require")); //'N/W G/W M3が必須入力項目です。ご確認ください。'
        return false;
      }
      if (this.missCartonInfo()) {
        this.$message("", this.$t("B0300.messages.errors.carton_require")); //'Carton Infoを入力してください。'
        return false;
      }
      if (!this.nwGwM3BiggerThanZero()) {
        this.$message("", this.$t("B0300.messages.errors.nw_gw_m3_gt0")); //'N/W,G/W,M3ゼロより大きい値を入力してください。'
        return false;
      }
      if (!this.perCartonEqual()) {
        this.$message(
          "",
          this.$t("B0300.messages.errors.per_carton_qty_invalid")
        ); //'「入数＊carton数＝数量」ルールを守ってください。'
        return false;
      }
      if (this.qtyIsNull()) {
        this.$message("", "Qty is null or qty is 0");
        return false;
      } else if (this.unitPriceIsNull()) {
        this.$message("", "Unit Price is null");
        return false;
      }
      return true;
    },

    amountEqual() {
      if (this.invoice.items[0].poId == null) {
        let items = this.invoice.items;
        let packages = this.invoice.packages.reduce((t, p) => {
          let subItem = t.find((i) => i.skuCode === p.skuCode);
          if (!subItem) {
            subItem = { skuCode: p.skuCode, qty: p.totalQty };
            t.push(subItem);
          } else {
            subItem.qty += p.totalQty;
          }
          return t;
        }, []);
        for (var k = 0; k < items.length; k++) {
          for (var l = 0; l < packages.length; l++) {
            if (
              items[k].skuCode === packages[l].skuCode &&
              items[k].qty != packages[l].qty
            ) {
              return false;
            }
          }
        }
        return true;
      }

      let items = this.invoice.items;
      let packages = this.invoice.packages.reduce((t, p) => {
        let subItem = t.find((i) => i.poNo === p.poNo);
        if (!subItem) {
          subItem = { poNo: p.poNo, qty: p.totalQty };
          t.push(subItem);
        } else {
          subItem.qty += p.totalQty;
        }
        return t;
      }, []);

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < packages.length; j++) {
          if (
            items[i].poNo === packages[j].poNo &&
            items[i].qty != packages[j].qty
          ) {
            return false;
          }
        }
      }
      return true;
    },
    hasPoint(x) {
      var y = String(x).indexOf(".") + 1; //获取小数点的位置
      if (y > 0) {
        return true;
      } else {
        return false;
      }
    },

    hasDifBu() {
      var bu = this.invoice.items
        .filter((i) => !!i.buName)
        .map((i) => i.buName)
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i);
          }
          return t;
        }, []);
      if (bu.length > 1) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      if (this.mixedSku) {
        this.$message("", "１件のINVに諸掛と品番が同時に存在できません。");
        return;
      } else if (this.invoice.items[0].poId == null) {
        this.doSave();
      } else if (
        this.invoice.dischargePortCode !=
          this.invoice.items[0].dischargePortCode ||
        this.invoice.loadingPortCode != this.invoice.items[0].loadingPortCode
      ) {
        this.$confirm({
          content:
            "P/Oの積出港・陸揚港とINVの積出港・陸揚港が不一致ですが、次に進めますか？",
        }).then(() => {
          this.doSave();
        });
      } else {
        this.doSave();
      }
    },
    doSave() {
      if (!this.canSave()) {
        return;
      } else {
        this.invoice.packages.forEach((p, index) => {
          p.seq = new Date().getTime() + index;
        });
        this.$http
          .post("commercial-invoices", {
            ...this.invoice,
            packages: this.invoice.packages.map((i) => {
              if (i.item) {
                i.currencyCode = this.invoice.currencyCode;
                i.unitPrice = i.item.unitPrice;
              }
              return i;
            }),
          })
          .then((res) => {
            console.log(res.data);
            this.$message("", this.$t("app.messages.saveSuccess")); //'保存が完了しました。'
            this.$router.push({
              name: "EditB0301",
              query: { id: res.data.id },
            });
          })
          .catch((res) => {
            this.showError(res);
          });
      }
    },
    back() {
      this.$router.push("/b0300");
    },
    remove() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        this.$http
          .delete(`commercial-invoices/${this.invoice.id}`)
          .then(() => {
            this.$router.push("/b0300");
            this.$message("", "Invoice削除ができました。"); //invoice 削除成功
          })
          .catch(() => {
            this.$message("", "該当Invoiceが使用済です。"); //invoice 已使用
          });
      });
    },
    calPackagesAmount() {
      return this.invoice.packages.reduce((g, p) => {
        let item = g.filter((i) => i.poNo === p.poNo);
        if (item) {
          item.subTotal += p.totalQty;
          item.poNo = p.poNo;
        } else {
          g.push({
            seq: p.itemSeq,
            subTotal: p.totalQty,
            poNo: p.poNo,
          });
        }
        return g;
      }, []);
    },
    showError(res) {
      if (this.errors[res.response.data.message]) {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.errors[res.response.data.message]
        );
      } else {
        this.$message(
          this.$t("app.messages.errors.title"),
          this.$t("app.system.error")
        );
      }
    },
    findItem(poNo) {
      return this.invoice.items.filter((i) => i.poNo == poNo);
    },
    calItem() {
      return this.invoice.items
        .map((i) => i.poNo)
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i);
          }
          return t;
        }, []);
    },
    calPackage() {
      return this.invoice.packages
        .map((i) => i.poNo)
        .reduce((t, i) => {
          if (t.indexOf(i) == -1) {
            t.push(i);
          }
          return t;
        }, []);
    },
    missNwGwM3() {
      return (
        this.invoice.packages.filter(
          (p) => !p.totalGrossWeight || !p.totalVolume || !p.totalNetWeight
        ).length > 0
      );
    },
    nwGwM3BiggerThanZero() {
      return (
        this.invoice.packages.filter(
          (p) =>
            p.totalGrossWeight > 0 && p.totalVolume > 0 && p.totalNetWeight > 0
        ).length === this.invoice.packages.length
      );
    },
    qtyIsNull() {
      return (
        this.invoice.items.filter((i) => i.qty === null || i.qty === 0).length >
        0
      );
    },
    unitPriceIsNull() {
      console.log(this.invoice.items.filter((i) => !i.unitPrice).length > 0);
      return this.invoice.items.filter((i) => !i.unitPrice).length > 0;
    },
    perCartonEqual() {
      return (
        this.invoice.packages.filter(
          (p) =>
            (p.cartonEndNo - p.cartonStartNo + 1) * p.perCartonQty == p.totalQty
        ).length === this.invoice.packages.length
      );
    },
    missCartonInfo() {
      return (
        this.invoice.packages.filter(
          (p) => !p.cartonStartNo || !p.cartonEndNo || !p.perCartonQty
        ).length > 0
      );
    },
  },
  watch: {
    // 'invoice.companyId'() {
    //   this.invoice.buId = null
    // },
  },
  computed: {
    incotermKvUrl() {
      if (this.$route.query.type === "paid" || this.invoice.isPaid) {
        return "incoterms/kv/paid-type/TYPE_PAID";
      }
      if (this.$route.query.type === "unpaid" || !this.invoice.isPaid) {
        return "incoterms/kv/paid-type/TYPE_UNPAID";
      }
      return "";
    },
    hasZG() {
      return this.invoice.items.filter((i) => i.skuCode === "諸掛").length > 0;
    },
    hasSku() {
      return this.invoice.items.filter((i) => i.skuCode !== "諸掛").length > 0;
    },
    mixedSku() {
      return (
        this.invoice.items.filter((i) => i.skuCode === "諸掛").length > 0 &&
        this.invoice.items.filter((i) => i.skuCode !== "諸掛").length > 0
      );
    },
    canRemove() {
      return this.invoice.isUsed == false && !this.isFormalSa && !this.isPreSa;
    },
    editable() {
      return !this.invoice.isUsed == true;
    },
    isFormalSa() {
      return this.invoice.type === "FORMALSA";
    },
    isPreSa() {
      return this.invoice.type === "PRESA";
    },
    companyEditable() {
      return this.buEditable; //this.editable && this.invoice.id == null;
    },
    buEditable() {
      return this.editable && ((this.invoice.id == null && this.$route.query.type === 'unpaid') || this.invoice.isPaid == false);
    },
    partnerEditable() {
      return (
        this.editable &&
        //this.invoice.items.length > 0 && //没有item时海外取引先可以編集
        this.invoice.items.every((p) => !p.poNo || p.poNo === "")
      );
    },
  },
};
</script>
